module.exports = __webpack_public_path__ + "img/app2.9d0ad044.jpg";